import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { licensedFilterList } from '@components/shared/license/license.constants';
import { enumMapper, RobotType, } from '@models';
import { encodeFilters, IGridSource, ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { LicenseUrlMapBackOffice, ModalService, ODataQueryOptions, RuntimeLicenseService, } from '@services';
import UiValidators, { INT32_MAX } from '@validators';
import { map, takeUntil, } from 'rxjs/operators';
import { RuntimeEditModalComponent } from '../../modals';
var BackOfficeSource = /** @class */ (function () {
    function BackOfficeSource(_runtimeLicense) {
        this._runtimeLicense = _runtimeLicense;
    }
    Object.defineProperty(BackOfficeSource.prototype, "mapper", {
        get: function () {
            return this._runtimeLicense.mapper;
        },
        enumerable: true,
        configurable: true
    });
    BackOfficeSource.prototype.get = function (qo) {
        return this._runtimeLicense.getLicenseDetails(this.licenseType, qo)
            .pipe(map(function (res) { return ({
            data: res.data.map(function (license) { return (tslib_1.__assign({}, license, { id: license.key })); }),
            total: res.total,
        }); }));
    };
    return BackOfficeSource;
}());
export { BackOfficeSource };
// FIXME: expose these from a common source
var ROBOT_TYPES = enumMapper(RobotType, {
    resourceKey: 'RobotType',
});
var ɵ0 = urlStateHandler;
var RuntimeLicenseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RuntimeLicenseComponent, _super);
    function RuntimeLicenseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.licensedFilterList = licensedFilterList();
        _this.validators = UiValidators.range(1, INT32_MAX);
        _this.encodeFilters = encodeFilters;
        _this.isMachinesEditGranted$ = _this._appState.user.permissions.isGranted('Machines.Edit');
        _this._modalService = _this._injector.get(ModalService);
        _this._licenseService = _this._injector.get(RuntimeLicenseService);
        _this.getRobotType = function (type) { return ROBOT_TYPES.find(function (t) { return t.label === type; }); };
        return _this;
    }
    RuntimeLicenseComponent.prototype.ngOnInit = function () {
        var svc = this._service;
        svc.licenseType = this.licenseType;
    };
    RuntimeLicenseComponent.prototype.editRuntime = function (entry) {
        var _this = this;
        this._modalService
            .openModal(RuntimeEditModalComponent, {
            id: entry.machineId,
            name: entry.machineName,
            nonProductionSlots: entry.runtimes,
            unattendedSlots: entry.runtimes,
        }, {
            data: this.licenseType,
        })
            .afterClosedResult()
            .subscribe(function () { return _this._refresh$.next(); });
    };
    RuntimeLicenseComponent.prototype.handleMachineToggle = function (entry, elem) {
        var _this = this;
        if (entry.enabled) {
            elem.checked = true;
            this._modalService.onConfirm(null, function () {
                elem.checked = false;
                _this._setMachineState(entry, false);
            }, function () { }, this._translate.instant('license_runtime_grid_disable_confirmation', {
                machineName: entry.machineName,
            }));
        }
        else {
            elem.checked = true;
            this._setMachineState(entry, true);
        }
    };
    RuntimeLicenseComponent.prototype._setMachineState = function (entry, active) {
        var _this = this;
        this.loading$.next(true);
        this._grid.dataManager.patchRow(entry.id, {
            enabled: active,
        });
        this._licenseService
            .toggleEnabled(entry, this.licenseType)
            .pipe(takeUntil(this._destroyed$)).subscribe(function () { return _this._refresh$.next(); }, function () { return _this._refresh$.next(); });
    };
    return RuntimeLicenseComponent;
}(ODataGridComponent));
export { RuntimeLicenseComponent };
export { ɵ0 };
